import React from 'react';

import { AdminUserManagementPage } from '../../admin-users/components/AdminUserManagementPage';

export default function AdminUsersIndexPage() {
    return <AdminUserManagementPage />;
}
